import * as React from "react";
import * as moment from "moment";

interface IProps {
  timeZone: string;
}

export class TimeZoneCell extends React.Component<IProps> {
  public render() {
    const { timeZone } = this.props;

    const currentTime = moment.tz(timeZone).format("HH:mm");

    return (
      <span>
        {currentTime}
        <span className="time-zone"> {timeZone}</span>
      </span>
    );
  }
}

export default TimeZoneCell;



// WEBPACK FOOTER //
// ./src/components/TimeZoneCell.tsx